import { v4 as uuidv4 } from 'uuid';

export function computeIRI(baseIRI, useSlashIRI, useUuidIRI, label, language, mode = "STANDARD") {
    // Properties generally start with a lower case letter
    if (mode === "PROPERTY") {
        label = label.charAt(0).toLowerCase() + label.substring(1);
    }
    // Remove spaces from labels
    label = label.replace(" ", "");
    const slashHash = useSlashIRI ?
        baseIRI.endsWith('/') ?
            ''
            :
            '/'
        :
        '#';
    const iriID = useUuidIRI ?
        uuidv4()
        :
        mode === "LABEL" ?
            "label-" + encodeURIComponent(label) + "-" + language
            :
            encodeURIComponent(label);
    const resourceIRI = baseIRI + slashHash + iriID;
    return resourceIRI;
}

export function getIRIsForProperty(data, property) {
    if (typeof data[property] === "object" && !Array.isArray(data[property])) {
        return [data[property].id];
    }
    else if (Array.isArray(data[property])) {
        return data[property].map(item => {
            if (typeof item === "object") {
                return item.id;
            }
            else return item;
        });
    }
    else if (data[property]) {
        return [data[property]];
    }
    return [];
}

export function getIRIsForPropertyList(data, propertyList) {
    if (!propertyList) return [];
    let iris = [];
    propertyList.forEach(p => iris = iris.concat(getIRIsForProperty(data, p)));
    return iris.flat();
}

export function getValuesForPropertyList(data, propertyList) {
    if (!propertyList) return [];
    let values = [];
    propertyList.forEach(p => {
        if (p in data && data[p] !== undefined) values = values.concat(data[p]);
    });
    return values.flat();
}

